var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvertIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50005 0.799988H7.86224V0.828562C4.18985 1.15249 1.30005 4.24485 1.30005 7.99999C1.30005 11.7551 4.18985 14.8475 7.86224 15.1714V15.2H8.50005C12.4701 15.2 15.7001 11.9701 15.7001 7.99999C15.7001 4.02991 12.4701 0.799988 8.50005 0.799988ZM2.57567 7.99999C2.57567 4.94878 4.89437 2.42917 7.86224 2.11005V13.89C4.89437 13.5708 2.57567 11.0512 2.57567 7.99999Z",
    fill: "#323538"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertIcon);
export default __webpack_public_path__ + "static/media/invert-icon.90be1b78bb2a4a9980ea7da0a8b38761.svg";
export { ForwardRef as ReactComponent };